const forgotFormErrorCodes = {
  EMAIL_INVALID: 'email.invalid',
  UNABLE_LOCATE_ACCOUNT: 'unable.locate.account',
  UNABLE_LOCATE_ACCOUNT_PASSWORD: 'unable.locate.account.password',
};

export default forgotFormErrorCodes;
